<template>
  <div class="invoice-tax-rate-add">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div style="display: flex;justify-content: flex-start;">
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">服务商名称：</span>
          </div>
          <el-input v-model="formData.name" size="small" style="width: 220px" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">服务类目：</span>
          </div>
          <el-select v-model="formData.valueaddItemCodes" size="small" style="width: 220px">
            <el-option v-for="item in categoryList" :key="item.code"
                       :label="item.name" :value="item.code">
            </el-option>
          </el-select>
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">子类目：</span>
          </div>
          <el-select v-model="formData.valueaddItemCodesChild" size="small" style="width: 220px">
            <el-option v-for="item in valueaddItemChildList" :key="item.code"
                       :label="item.name" :value="item.code">
            </el-option>
          </el-select>
        </div>
      </div>

      <div style="display: flex;justify-content: flex-start;">
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">联系人姓名：</span>
          </div>
          <el-input v-model="formData.contactName" size="small" style="width: 220px" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">联系人手机：</span>
          </div>
          <el-input v-model="formData.contactPhone" size="small" style="width: 220px" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <span class="line-text">价格：</span>
          </div>
          <el-input v-model="formData.price" size="small" style="width: 220px" />
        </div>
      </div>

      <div style="display: flex;justify-content: flex-start;">
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">收款账户：</span>
          </div>
          <el-select v-model="formData.accountCode" size="small" style="width: 220px">
            <el-option v-for="item in accountList" :key="item.code"
                       :label="item.mchName" :value="item.code">
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">服务商及商品介绍：</span>
        </div>
        <!--<el-input v-model="formData.introduction" type="textarea" :rows="3" size="small" style="width: 280px" />-->
        <div class="editorBox">
          <quill-editor ref="QuillEditor"
                        v-model="formData.introduction"
                        class="ql-editor"
                        :options="editorOption"
                        @blur="onEditorBlur($event)"
                        @focus="onEditorFocus($event)"
                        @ready="onEditorReady($event)">
          </quill-editor>
        </div>
      </div>

      <!--<div class="form-line">-->
        <!--<div class="textBox">-->
          <!--<span class="line-text">备注：</span>-->
        <!--</div>-->
        <!--<el-input v-model="formData.memo" type="textarea" :rows="3" size="small" style="flex: 1;" />-->
      <!--</div>-->

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>

    <div style="width: 0px;height: 0px;" id="showImageDialogVisible" @click="chooseImageDialogVisible = true"></div>

    <el-dialog title="选择图片" :visible.sync="chooseImageDialogVisible" width="500px">
      <div>
        <upload-img-list @getImgList="getImgList" :ImgNumber="1" style="margin: 0 auto" v-if="chooseImageDialogVisible" />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="chooseImageDialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="uploadImg" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../utils/toBase64'
  import $ from 'jquery'
  import {api} from '../../api/ValueAdded'
  import {bus} from '../../../utils/bus'
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'
  import UploadImgList from '../../../components/Input/UploadImgList'

  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],

    [{'header': 1}, {'header': 2}],               // custom button values
    [{'list': 'ordered'}, {'list': 'bullet'}],
    [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
    [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
    [{'direction': 'rtl'}],                         // text direction

    [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
    [{'header': [1, 2, 3, 4, 5, 6, false]}],

    [{'color': []}, {'background': []}],          // dropdown with defaults from theme
    [{'font': []}],
    [{'align': []}],
    ['link', 'image'],
    ['clean']                                         // remove formatting button
  ]

  export default {
    components: {
      UploadImgList,
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'service-provider-add',
    data () {
      return {
        breadcrumb: [{
          value: '严选服务',
          name: 'service-over-view'
        }, {
          value: '服务商管理'
        }],
        mainTitle: '添加服务商',
        subheading: '',

        categoryList: [],
        categoryCodeArr: [],

        valueaddItemChildList: [],

        accountList: [],
        formData: {
          name: '',
          valueaddItemCodes: '',
          valueaddItemNames: '',
          valueaddItemCodesChild: '',
          valueaddItemNamesChild: '',
          contactName: '',
          contactPhone: '',
          introduction:  '',
          price: '',
          accountCode: '',
          accountName: '',
          memo: ''
        },

        chooseImageDialogVisible: false,
        imageList: [],
        base64List: [],
        editorOption: {
          modules: {
            toolbar: {
              container: toolbarOptions,  // 工具栏
              handlers: {
                'image': function (value) {
                  if (value) {
                    document.querySelector('#showImageDialogVisible').click()
                  } else {
                    this.quill.format('image', false);
                  }
                }
              }
            }
          }
        },
      }
    },
    created () {
      this.getValueAddItemList()
      this.getAccountList()
    },
    methods: {
      // 查询服务类目
      getValueAddItemList () {
        this.$axios.post(`${api.getValueAddItemList}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let list = res.data.data
              this.categoryList = list
            }
          })
          .catch(errorHandler('查询失败'))
      },
      // 查询子类目列表
      getValueAddItemByCode () {
        this.$axios.get(`${api.getValueAddItemByCode}/${this.formData.valueaddItemCodes}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let resData = res.data.data
              this.valueaddItemChildList = resData.valueaddItemChildList || []
              let childInList = false
              this.valueaddItemChildList.map(v => {
                if (v.code === this.formData.valueaddItemCodesChild) {
                  childInList = true
                }
              })
              if (!childInList) {
                this.formData.valueaddItemCodesChild = ''
                this.formData.valueaddItemNamesChild = ''
              }
            }
          })
          .catch(errorHandler('查询失败'))
      },
      getAccountList () {
        this.$axios.get(`${api.getAccountList}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let list = res.data.data
              this.accountList = list
            }
          })
          .catch(errorHandler('查询失败'))
      },

      toManagePage () {
        this.$router.push({
          name: 'service-provider-manage'
        })
      },

      getImgList (imageList, base64List) {
        this.imageList = imageList
        this.base64List = base64List
      },

      onEditorBlur(editor) {},
      onEditorFocus(editor) {},
      onEditorReady(editor) {},
      onEditorChange({ editor, html, text }) {
        // console.log('editor change!', editor, html, text)
        this.formData.introduction = html
      },
      // 上传图片
      uploadImg () {
        if (this.base64List.length < 0) {
          nError('请选择图片')
          return false
        }
        this.$axios.post(api.uploadImg, {
          picData: this.base64List[0].personImageStr
        })
          .then(res => {
            if (res.data.retCode === 1) {
              // this.content += `<img src="${res.data.data}">`
              // console.log(this.content)
              let quill = this.$refs.QuillEditor.quill

              let length = quill.selection.savedRange.index

              quill.insertEmbed(length, 'image', res.data.data)

              quill.setSelection(length + 1)
              this.chooseImageDialogVisible = false
              this.imageList = []
              this.base64List = []
            } else {
              // 提示信息，需引入Message
              nError('图片插入失败')
            }
          })
          .catch(errorHandler('图片插入失败'))
      },

      confirm () {
        if (!this.formData.name) {
          nError('请输入服务商名称')
          return false
        }
        if (!this.formData.valueaddItemCodes) {
          nError('请选择服务类目')
          return false
        }
        if (!this.formData.valueaddItemCodesChild) {
          nError('请选择子类目')
          return false
        }
        if (!this.formData.contactName) {
          nError('请输入联系人')
          return false
        }
        if (!this.formData.contactPhone) {
          nError('请输入联系人手机')
          return false
        }
        if (!this.formData.accountCode) {
          nError('请选择收款账户')
          return false
        }
        this.accountList.map(v => {
          if (v.code === this.formData.accountCode) {
            this.formData.accountName = v.mchName
          }
        })
        this.categoryList.map(v => {
          if (v.code === this.formData.valueaddItemCodes) {
            this.formData.valueaddItemNames = v.name
          }
        })
        this.valueaddItemChildList.map(v => {
          if (v.code === this.formData.valueaddItemCodesChild) {
            this.formData.valueaddItemNamesChild = v.name
          }
        })
        this.$axios.post(api.valueAddProviderAdd, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('添加成功')
              this.toManagePage()
            }
          })
          .catch(errorHandler('添加失败'))
      },
      cancel () {
        this.toManagePage()
      }
    },

    watch: {
      'formData.valueaddItemCodes': {
        handler(newValue, oldValue) {
          this.getValueAddItemByCode()
        },
        deep: true
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    width: 160px;
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 160px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 110px 0 140px;
    margin: 40px auto 0;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 36px;
    line-height: 120px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 50px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }

</style>

<style lang="less">
  .invoice-tax-rate-add {
    .el-switch {
      height: 30px;
    }
    .el-input-number.is-controls-right .el-input__inner {
      text-align: left;
    }

    .editorBox {
      min-height: 240px;
      .quill-editor {
        width: 1050px;
        min-height: 240px;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
      }
      .ql-editor {
        padding: 0;
      }
      .ql-container {
        height: 60%;
        flex: 1;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/ValueAddedService/ServiceProvider/ServiceProviderAdd.vue